// tslint:disable: max-line-length
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useLocation, useNavigate } from 'react-router-dom';
import { showErrorMessage } from '../../helpers/showMessage';
import { updateProfile } from './apicaller';
import { EMAIL_REGEX } from '../../utils/regex';
import { NotLoggedInHeader } from './../../app/common/sharedComponents/NotLoggedInHeader';
import { useTranslation } from 'react-i18next';
import { SuccessCheck } from '../../app/common/icons/SuccessCheck';
import {
  Body4,
  Body5,
  Body6,
  Headline1,
  Headline3,
} from '../../app/common/typography';
import { ButtonLarge } from '../../app/common/sharedComponents/buttons/ButtonLarge';
import { GradientDownArrows } from '../../app/common/icons/Register/GradientDownArrows';
import { SeparatorWithDownArrow } from '../../app/common/icons/Register/SeparatorWithDownArrow';
import {
  BenefitContainer,
  BenefitsContainer,
  FormContainer,
  GradientContainer,
  GradientDownArrowContainer,
  IntroducingMembershipTitleContainer,
  LoginLink,
  MembershipGradientTextContainer,
  InputContainer,
  SuccessCheckIconContainer,
  InputNotesContainer,
  SuccessfulRegistrationTextContainer,
  SuccessfulRegistrationContainer,
  MembershipInfoContainer,
  Container,
  SpacerSection,
} from './styled.myLqaProfile';
import { SuccessCheckFilled } from '../../app/common/icons/SuccessCheckFilled';
import { TextInput } from '../../app/common/sharedComponents/TextInput';

const TopSection = styled('div')`
  position: fixed;
  background: white;
  width: 100%;
  z-index: 99;
`;

const MyLQAProfile = () => {
  const { t } = useTranslation();
  const regex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^~])[A-Za-z\d@$!%*?&#^~]{0,}$/;
  const location = useLocation();
  const loc: any = { ...location };
  const { accessToken, userData } = loc.state;
  const navigate = useNavigate();

  const lqaBenefits = [
    t('COMMON.REGISTER.MESSAGES.BENEFITS.PERSONAL_MEMBERSHIP_ALWAYS_FREE'),
    t(
      'COMMON.REGISTER.MESSAGES.BENEFITS.ACHIEVE_SCORES_LEVELS_POINTS_BY_ACTIVITIES'
    ),
    t(
      'COMMON.REGISTER.MESSAGES.BENEFITS.ACHIEVEMENTS_THROUGHOUT_CAREER_WITH_LQA'
    ),
    t(
      'COMMON.REGISTER.MESSAGES.BENEFITS.MYLQA_HELPS_GROW_CAREER_IN_LUXURY_SERVICE'
    ),
  ];

  const verifyTokenData = () => {
    setTimeout(() => {
      window.location.href = `/register-success/register?isRegistered=true`;
    }, 1000);
  };
  const [form, setForm] = useState({
    email: '',
    userPassword: '',
    confirmUserPassword: '',
  });

  const step = 3;

  const updatePersonalEmailHandler = () => {
    // validate email, password, confirm password
    if (
      form.email === '' ||
      !EMAIL_REGEX.test(form.email) ||
      form.userPassword === '' ||
      form.confirmUserPassword === '' ||
      form.userPassword.length < 7 ||
      !regex.test(form.userPassword) ||
      !(form.userPassword === form.confirmUserPassword)
    ) {
      showErrorMessage('Please fill all data');
      return;
    }
    if (userData.userEmail.toLowerCase() === form.email.toLowerCase()) {
      showErrorMessage('Use personal email instead of hotel email');
      return;
    }
    const payLoad = {
      password: form.userPassword,
      userEmail: form.email.toLowerCase().trim(),
    };
    updateProfile(payLoad, accessToken)
      .then(() => {
        window.location.href = `/register-success/register`;
      })
      .catch(() => {
        showErrorMessage('Please enter your valid email address.');
      });
  };

  const signInHandler = () => {
    navigate('/myLqaProfile/signIn', { state: { accessToken, userData } });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container>
      <TopSection>
        <NotLoggedInHeader
          isRegistering={true}
          step={step}
        />
      </TopSection>
      <SpacerSection />
      <SuccessfulRegistrationContainer>
        <SuccessCheck />
        <SuccessfulRegistrationTextContainer>
          <Headline3>
            {t('COMMON.REGISTER.MESSAGES.SUCCESSFULLY_REGISTERED_WITH_HOTEL')}
          </Headline3>
        </SuccessfulRegistrationTextContainer>
      </SuccessfulRegistrationContainer>
      <GradientContainer>
        <ButtonLarge
          title={t('COMMON.REGISTER.BUTTONS.LOGIN_NOW_TO_USE_MYLQA')}
          onClick={verifyTokenData}
        />
        <GradientDownArrowContainer>
          <GradientDownArrows />
          <MembershipGradientTextContainer>
            <Headline3 color="oxfordBlue">
              {t('COMMON.REGISTER.LABELS.BUT_WAIT')}
            </Headline3>
            <Headline1 color="deepTeal">
              {t('COMMON.REGISTER.LABELS.GET_MORE_FROM_MYLQA')}
            </Headline1>
            <SeparatorWithDownArrow />
            <IntroducingMembershipTitleContainer>
              <Headline3 color="titleBlue">
                {t('COMMON.REGISTER.LABELS.INTRODUCING_MYLQA_MEMBERSHIP')}
              </Headline3>
            </IntroducingMembershipTitleContainer>
            <Body5 color="dimGray">
              {t('COMMON.REGISTER.LABELS.CREATE_MEMBERSHIP_INVITATION_NOTE')}{' '}
              <LoginLink onClick={signInHandler}>
                {t('COMMON.OUTSIDE.BUTTONS.SIGN_IN')}
              </LoginLink>
            </Body5>
          </MembershipGradientTextContainer>
        </GradientDownArrowContainer>
      </GradientContainer>
      <MembershipInfoContainer>
        <BenefitsContainer>
          {lqaBenefits.map((benefit: string, index: number) => {
            return (
              <BenefitContainer key={index}>
                <SuccessCheckIconContainer>
                  <SuccessCheckFilled />
                </SuccessCheckIconContainer>
                <Body4>{benefit}</Body4>
              </BenefitContainer>
            );
          })}
        </BenefitsContainer>

        <FormContainer>
          <InputContainer>
            <TextInput
              title={t('COMMON.REGISTER.LABELS.YOUR_PERSONAL_EMAIL')}
              textValue={form.email}
              onValueChange={(value: string) => {
                setForm({ ...form, email: value });
              }}
              placeholder={t(
                'COMMON.REGISTER.MESSAGES.ENTER_PERSONAL_EMAIL_PLACEHOLDER'
              )}
            />
            <InputNotesContainer>
              <Body6>
                {t(
                  'COMMON.REGISTER.MESSAGES.MEMBERSHIP_IS_YOURS_RECOMMEND__PERSONAL_EMAIL'
                )}
              </Body6>
            </InputNotesContainer>
          </InputContainer>

          <InputContainer>
            <TextInput
              title={t(
                'COMMON.REGISTER.LABELS.CREATE_PERSONAL_MYLQA_MEMBERSHIP_PROFILE_PASSWORD'
              )}
              textValue={form.userPassword}
              onValueChange={(value: string) => {
                setForm({ ...form, userPassword: value });
              }}
              inputType="password"
              placeholder={t(
                'COMMON.REGISTER.MESSAGES.ENTER_PERSONAL_PASSWORD_PLACEHOLDER'
              )}
            />
          </InputContainer>

          <InputContainer>
            <TextInput
              title={t(
                'COMMON.REGISTER.LABELS.CONFIRM_PERSONAL_MYLQA_MEMBERSHIP_PROFILE_PASSWORD'
              )}
              textValue={form.confirmUserPassword}
              onValueChange={(value: string) => {
                setForm({ ...form, confirmUserPassword: value });
              }}
              inputType="password"
              placeholder={t(
                'COMMON.REGISTER.MESSAGES.ENTER_PERSONAL_CONFIRM_PASSWORD_PLACEHOLDER'
              )}
            />
          </InputContainer>
        </FormContainer>

        <ButtonLarge
          title={t('COMMON.REGISTER.BUTTONS.CREATE_MEMBERSHIP')}
          onClick={updatePersonalEmailHandler}
        />
      </MembershipInfoContainer>
    </Container>
  );
};

export default MyLQAProfile;
